import { ChatJson } from "@xflr6/chatbot";
import axios from "axios";

import { SettingsPatch } from "../sharedTypes";
import { baseUrl } from "../utils";
import { HistoryUpdateResponse } from "./sharedTypes";

export interface ChatStub {
  name: string;
  tName: Record<string, string>;
  id: string;
  version: string;
}

export interface ChatSequenceHistoryResponse {
  identifier: string;
  history: {
    histories: (ChatJson | null)[];
    score: number | null;
    completed: boolean;
  };
  version: string;
  flowSequence: {
    name: string;
    tName: Record<string, string>;
    // The default language of the flow sequence. Use this value only if
    // `histories` is empty, i.e. if `histories[0]?.language` is not yet
    // available.
    language: string;
    languages: string[];
    flows: ChatStub[];
    nextComponentText: string | null;
    nextButtonText: string | null;
    lastComponentTest: string | null;
    lastButtonText: string | null;
  };
  updateToken: string;
  settings: SettingsPatch;
}

export async function getManagedChatSequence(
  chatSequenceId: string,
  identifier: string
): Promise<ChatSequenceHistoryResponse> {
  const _identifier = encodeURIComponent(identifier);
  const response = await axios.get(
    `${baseUrl}/managed_flow_sequences/${chatSequenceId}?identifier=${_identifier}`
  );
  return response.data;
}

export async function createManagedChatSequence(
  chatSequenceId: string,
  identifier?: string | null,
  type?: string | null
): Promise<ChatSequenceHistoryResponse> {
  const response = await axios.post(
    `${baseUrl}/managed_flow_sequences/${chatSequenceId}`,
    {
      ...(identifier != null
        ? {
            identifier,
          }
        : {}),
      ...(type != null
        ? {
            // NOTE: origin is hardcoded to aug if any type is passed
            // as that is only case when type would be passed.
            origin: "aug",
          }
        : {}),
    }
  );
  return response.data;
}

export async function getOrCreateManagedChatSequence(
  chatSequenceId: string,
  identifier?: string | null,
  type?: string | null
): Promise<ChatSequenceHistoryResponse> {
  if (identifier == null) {
    return createManagedChatSequence(chatSequenceId, identifier);
  } else {
    try {
      // NOTE: Catch won't work without await here
      return await getManagedChatSequence(chatSequenceId, identifier);
    } catch (e) {
      if (
        e.response.status === 404 &&
        e.response.data === "Identifier not found"
      ) {
        return createManagedChatSequence(chatSequenceId, identifier, type);
      } else {
        throw e;
      }
    }
  }
}

export async function updateManagedChatSequence(
  chatSequenceId: string,
  identifier: string,
  chatIndex: number,
  chatHistory: ChatJson,
  updateToken: string
): Promise<HistoryUpdateResponse> {
  const response = await axios.put(
    `${baseUrl}/managed_flow_sequences/${chatSequenceId}`,
    {
      identifier,
      chatIndex,
      chatHistory,
      updateToken,
    }
  );
  return response.data;
}
